import { render } from "./HeaderTitle.vue?vue&type=template&id=a37daa34&scoped=true"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"

import "./HeaderTitle.vue?vue&type=style&index=0&id=a37daa34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37daa34"]])

export default __exports__